// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';



export class PatchConfigData implements flatbuffers.IUnpackableObject<PatchConfigDataT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):PatchConfigData {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsPatchConfigData(bb:flatbuffers.ByteBuffer, obj?:PatchConfigData):PatchConfigData {
  return (obj || new PatchConfigData()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsPatchConfigData(bb:flatbuffers.ByteBuffer, obj?:PatchConfigData):PatchConfigData {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new PatchConfigData()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

fow():boolean {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
}

incomeMult():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

startIncome():number {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

winMapControlPercent():number {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

winAnnexAnyHq():boolean {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
}

requireCompleteKills():boolean {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
}

winMaxDays():number {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

maxUnitsPerPlayer():number {
  const offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

static startPatchConfigData(builder:flatbuffers.Builder) {
  builder.startObject(8);
}

static addFow(builder:flatbuffers.Builder, fow:boolean) {
  builder.addFieldInt8(0, +fow, +false);
}

static addIncomeMult(builder:flatbuffers.Builder, incomeMult:number) {
  builder.addFieldInt32(1, incomeMult, -1);
}

static addStartIncome(builder:flatbuffers.Builder, startIncome:number) {
  builder.addFieldInt32(2, startIncome, -1);
}

static addWinMapControlPercent(builder:flatbuffers.Builder, winMapControlPercent:number) {
  builder.addFieldInt32(3, winMapControlPercent, -1);
}

static addWinAnnexAnyHq(builder:flatbuffers.Builder, winAnnexAnyHq:boolean) {
  builder.addFieldInt8(4, +winAnnexAnyHq, +false);
}

static addRequireCompleteKills(builder:flatbuffers.Builder, requireCompleteKills:boolean) {
  builder.addFieldInt8(5, +requireCompleteKills, +false);
}

static addWinMaxDays(builder:flatbuffers.Builder, winMaxDays:number) {
  builder.addFieldInt32(6, winMaxDays, -1);
}

static addMaxUnitsPerPlayer(builder:flatbuffers.Builder, maxUnitsPerPlayer:number) {
  builder.addFieldInt32(7, maxUnitsPerPlayer, -1);
}

static endPatchConfigData(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createPatchConfigData(builder:flatbuffers.Builder, fow:boolean, incomeMult:number, startIncome:number, winMapControlPercent:number, winAnnexAnyHq:boolean, requireCompleteKills:boolean, winMaxDays:number, maxUnitsPerPlayer:number):flatbuffers.Offset {
  PatchConfigData.startPatchConfigData(builder);
  PatchConfigData.addFow(builder, fow);
  PatchConfigData.addIncomeMult(builder, incomeMult);
  PatchConfigData.addStartIncome(builder, startIncome);
  PatchConfigData.addWinMapControlPercent(builder, winMapControlPercent);
  PatchConfigData.addWinAnnexAnyHq(builder, winAnnexAnyHq);
  PatchConfigData.addRequireCompleteKills(builder, requireCompleteKills);
  PatchConfigData.addWinMaxDays(builder, winMaxDays);
  PatchConfigData.addMaxUnitsPerPlayer(builder, maxUnitsPerPlayer);
  return PatchConfigData.endPatchConfigData(builder);
}

unpack(): PatchConfigDataT {
  return new PatchConfigDataT(
    this.fow(),
    this.incomeMult(),
    this.startIncome(),
    this.winMapControlPercent(),
    this.winAnnexAnyHq(),
    this.requireCompleteKills(),
    this.winMaxDays(),
    this.maxUnitsPerPlayer()
  );
}


unpackTo(_o: PatchConfigDataT): void {
  _o.fow = this.fow();
  _o.incomeMult = this.incomeMult();
  _o.startIncome = this.startIncome();
  _o.winMapControlPercent = this.winMapControlPercent();
  _o.winAnnexAnyHq = this.winAnnexAnyHq();
  _o.requireCompleteKills = this.requireCompleteKills();
  _o.winMaxDays = this.winMaxDays();
  _o.maxUnitsPerPlayer = this.maxUnitsPerPlayer();
}
}

export class PatchConfigDataT implements flatbuffers.IGeneratedObject {
constructor(
  public fow: boolean = false,
  public incomeMult: number = -1,
  public startIncome: number = -1,
  public winMapControlPercent: number = -1,
  public winAnnexAnyHq: boolean = false,
  public requireCompleteKills: boolean = false,
  public winMaxDays: number = -1,
  public maxUnitsPerPlayer: number = -1
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return PatchConfigData.createPatchConfigData(builder,
    this.fow,
    this.incomeMult,
    this.startIncome,
    this.winMapControlPercent,
    this.winAnnexAnyHq,
    this.requireCompleteKills,
    this.winMaxDays,
    this.maxUnitsPerPlayer
  );
}
}
